import Vue from "vue"
import Vuex from "vuex";
import todos from "./modules/mixology"

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
       todos 
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js